import TextInput from 'src/hci/common/TextInput/TextInput';
import './TransparencyUrl.sass';
import Button from 'src/hci/common/Button/Button';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { getAccountPublicReportingApiKey } from 'src/components/Dashboard/ApplicationsArea/ReportingApp/ReportingAppSlice';
import useEnvSettings from 'src/helper/useEnvSettings';
import useDialog from 'src/helper/useDialog';
import Select from 'src/hci/common/Select/Select';

function TransparenctUrl() {
  const envSettings = useEnvSettings();
  const dispatch = useDispatch();
  const dialog = useDialog();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTimeZone, setSetselectedTimeZone] = useState('America/New_York');
  const publicReportKeyResult = useSelector(state => state.reportingApp.publicReportingApiKeyResult);
  const timezones = Intl.supportedValuesOf('timeZone');

  const generateTransparencyUrl = () => {
    setIsLoading(true);

    const baseUrlParts = envSettings?.configs?.auth?.redirectUri?.split('/');
    const domain = baseUrlParts?.slice(0, 3).join('/');

    dispatch(getAccountPublicReportingApiKey({
      timeZone: selectedTimeZone,
      expireTime: '2029-12-31T23:59:59Z',
      domain: domain
    }));
  }

  useEffect(() => {
    if(!publicReportKeyResult) return;

    if(isLoading && !publicReportKeyResult?.success) {
      dialog.fire({
        title: <b>Transparency URL</b>,
        text: "Failed to grab transparency URL",
        icon: 'error',
        showConfirmButton: true,
      });
    }

    setIsLoading(false);
  }, [publicReportKeyResult]);

  return (
    <div className='transparency-url'>
      <div className='item'>
        <div className="title">Public URL:</div>
        <TextInput value={publicReportKeyResult?.url} readOnly placeholder='The URL will display here...' />
      </div>
      <div className='item'>
        <div className="title">Timezone:</div>
        <Select
          value={selectedTimeZone} 
          onValueChange={value => setSetselectedTimeZone(value)}
          placeholder="Please select timezone" 
          content={[{
            items: timezones?.map(item => ({ value: item, label: item }))
          }]} 
          className="timezone-select"
        />
      </div>
      <Button loading={isLoading} onClick={generateTransparencyUrl}>Generate URL</Button>
    </div>
  )
}

export default TransparenctUrl